import { Injectable } from '@angular/core'
import { AppService } from '../../../../core/service/Base.Service';
import { GenEnum } from "../../../shared/general.enum";

@Injectable()
export class FOAdmEnquiryService extends AppService<any>{

    constructor() {
        super('FOAdmEnquiry');
    }

    async GetEnquiryList(entityid, sourcetypeid, responsetypeid, statusid, nextfollowup, fromdate, tilldate, batchid) {
        let refentityid = (entityid == undefined || entityid == 0 || entityid == "") ? this.localStorage.get("selectedEntity") : entityid;
        let refsourcetypeid = (sourcetypeid == undefined || sourcetypeid == 0 || sourcetypeid == "") ? 'null' : sourcetypeid;
        let refresponsetypeid = (responsetypeid == undefined || responsetypeid == 0 || responsetypeid == "") ? 'null' : responsetypeid;
        let refstatusid = (statusid == undefined || statusid == 0 || statusid == "") ? 'null' : statusid;
        let refnextfollowup = (nextfollowup == "" || nextfollowup == undefined) ? 'null' : nextfollowup;
        let reffromdate = (fromdate == "" || fromdate == undefined) ? 'null' : fromdate;
        let reftilldate = (tilldate == "" || tilldate == undefined) ? 'null' : tilldate;
        let retbatchid = (batchid == undefined || batchid == 0 || batchid == "") ? 'null' : batchid;

        const result = await this.get('Enquiries', [refentityid, refsourcetypeid, refresponsetypeid, refstatusid, refnextfollowup, reffromdate, reftilldate, retbatchid]);

        return result;
    }

    async getResponseType(entityid, sourcetypeid, responsetypeid, statusid, nextfollowup, fromdate, tilldate) {

        let refentityid = (entityid == undefined || entityid == 0 || entityid == "") ? this.localStorage.get("selectedEntity") : entityid;
        let refsourcetypeid = (sourcetypeid == undefined || sourcetypeid == 0 || sourcetypeid == "") ? 'null' : sourcetypeid;
        let refresponsetypeid = (responsetypeid == undefined || responsetypeid == 0 || responsetypeid == "") ? 'null' : responsetypeid;
        let refstatusid = (statusid == undefined || statusid == 0 || statusid == "") ? 'null' : statusid;
        let refnextfollowup = (nextfollowup == "" || nextfollowup == undefined) ? 'null' : nextfollowup;
        let reffromdate = (fromdate == "" || fromdate == undefined) ? 'null' : fromdate;
        let reftilldate = (tilldate == "" || tilldate == undefined) ? 'null' : tilldate;

        const result = await this.get('ResponseType', [refentityid, refsourcetypeid, refresponsetypeid, refstatusid, refnextfollowup, reffromdate, reftilldate]);

        return result;
    }

    async getEntityEnquiry(entityid, courseid, batchid) {
        const result = await this.get('EntityEnquires', [entityid, courseid, batchid]);
        return result;
    }


    async getInterstedEnquiry(entityid, batchid, enquiryid,appid) {
        const result = await this.get('EntityEnquiry', [entityid, batchid, GenEnum.Respose_Type.Intrested, GenEnum.Status.Open, enquiryid,appid]);
        return result;
    }

    async getEnquirychildren(entityid, enquiryid) {
        const result = await this.get('EnquiryChildren', [entityid, enquiryid]);
        return result;
    }
}



// WEBPACK FOOTER //
// ./src/app/shell/forms/front-office/admissionenquiry/admissionenquiry.service.ts